/* eslint-disable unused-imports/no-unused-vars */
import { readonly } from 'vue'
import { createPrefixer } from '.'

const ROOT = 'ver-cuentas-x-cobrar' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pt = createPrefixer(ROOT, 'transacciones')

const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')
const pm = createPrefixer(ROOT, 'mantenimiento')
export const RESOURCE_CUENTAS_X_COBRAR = 'Cuentas X Cobrar PG' as const

const permission = readonly({
    _root: ROOT,
    _resource: RESOURCE_CUENTAS_X_COBRAR,
    transacciones: {
        _perm: rp('transacciones'),
    },
    configuracion: {
        _perm: rp('configuracion'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
    },
    informes: {
        _perm: rp('informes'),
    },
} as const)
export default permission
